import AiEquipmentTrackingWrogInformationList from 'modules/analytics/components/AiEquipmentTrackingWrogInformationList/AiEquipmentTrackingWrogInformationList';
import AiPeopleFlowWrongInformationList from 'modules/analytics/components/AiPeopleFlowWrongInformationList/AiPeopleFlowWrongInformationList';
import useAiEquipmentTrackingListData from 'modules/analytics/hooks/useAiEquipmentTrackingListData';

const AiEquipmentTrackingPage = () => {
    const { data: logs, isLoading } = useAiEquipmentTrackingListData();

    // return (
    //     <PageTemplate>
    //         <PageHeading className="flex justify-between items-center">
    //             <div>AI People Flow</div>
    //         </PageHeading>

    //         <div>
    //             <AiPeopleFlowWrongInformationList isLoading={isLoading} AiPeoplFlow={logs} />
    //         </div>
    //     </PageTemplate>
    // );s

    return (
        <div>
            <AiEquipmentTrackingWrogInformationList isLoading={isLoading} AiEquipementTrackling={logs} />
        </div>
    );
};

export default AiEquipmentTrackingPage;
